export enum SocialButtonVariantEnum {
  Primary = 'primary',
  Secondary = 'secondary',
  Light = 'light',
  Dark = 'dark',
  Inline = 'inline',
}
